var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35681 13.2858V4.40576H5.66601C6.27081 4.40576 6.77901 4.50576 7.19061 4.70576C7.61061 4.90576 7.92981 5.17376 8.14821 5.50976C8.36661 5.83776 8.47581 6.20176 8.47581 6.60176C8.47581 6.99376 8.40021 7.32176 8.24901 7.58576C8.09781 7.84177 7.91301 8.04976 7.69461 8.20976C7.48461 8.36176 7.27881 8.46577 7.07721 8.52176V8.61776C7.30401 8.66576 7.55601 8.76973 7.83321 8.92976C8.11041 9.08979 8.34981 9.31779 8.55141 9.61376C8.75301 9.90973 8.85381 10.2937 8.85381 10.7658C8.85381 11.1817 8.74881 11.5818 8.53881 11.9658C8.33721 12.3498 8.00541 12.6658 7.54341 12.9138C7.08981 13.1617 6.49761 13.2858 5.76681 13.2858H1.35681ZM5.33841 5.95376H3.29721V8.01776H5.33841C5.77521 8.01776 6.09441 7.91776 6.29601 7.71776C6.49761 7.51776 6.59841 7.27376 6.59841 6.98576C6.59841 6.70576 6.49761 6.46576 6.29601 6.26576C6.09441 6.05776 5.77521 5.95376 5.33841 5.95376ZM5.48961 9.43376H3.29721V11.7378H5.48961C5.98521 11.7378 6.34221 11.6257 6.56061 11.4018C6.78741 11.1697 6.90081 10.8937 6.90081 10.5738C6.90081 10.2618 6.78741 9.99373 6.56061 9.76976C6.34221 9.54579 5.98521 9.43376 5.48961 9.43376Z",
    fill: "#D4D4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65005 3.21423H2.30005V4.92852H3.65005V3.21423Z",
    fill: "#D4D4D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90005 3.21423H4.55005V4.92852H5.90005V3.21423Z",
    fill: "#D4D4D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65005 12.6428H2.30005V14.3571H3.65005V12.6428Z",
    fill: "#D4D4D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90005 12.6428H4.55005V14.3571H5.90005V12.6428Z",
    fill: "#D4D4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.70b9f4b536a2675a6b3906609457d86e.svg";
export { ForwardRef as ReactComponent };